export const landingPagesErrorMessages = {
  INVALID_CRITERIA_OBJECT: 'Invalid criteria object',
};
